module.exports = __webpack_public_path__ + "assets/img/loginMask.909e615a.png";